import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./chevron-left.svg?react";

export const ChevronLeftIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
